/**
 * @fileoverview POST handler for the "/companies/:company_id/developers" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersCacheKeys } from "./constants";
import type { PostCompaniesCompanyIdDevelopersProps, CompaniesCompanyIdDevelopersResult } from "./types";

export const postCompaniesCompanyIdDevelopers = reactQueryMutationAdapter(
  companiesCompanyIdDevelopersCacheKeys,
  (props: PostCompaniesCompanyIdDevelopersProps): Promise<CompaniesCompanyIdDevelopersResult> => {
    // manipulate props here as needed param2

    return fetch(`/companies/${props.companyId}/developers`, "POST", props.body);
  }
);
